import React from 'react';
import AbstractIcon from './AbstractIcon';
var Icon = /*#__PURE__*/React.forwardRef(function (props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "currentcolor",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M11.3719 23.9835C17.9902 24.3304 23.6366 19.2464 23.9835 12.628C24.3304 6.00968 19.2463 0.363285 12.628 0.0164326C6.00964 -0.33042 0.363244 4.75362 0.016392 11.372C-0.0125124 11.9235 0.411158 12.394 0.962686 12.4229C1.51421 12.4518 1.98475 12.0282 2.01365 11.4766C2.30269 5.96135 7.00803 1.72465 12.5233 2.01369C18.0386 2.30274 22.2753 7.00807 21.9862 12.5233C21.6972 18.0386 16.9919 22.2753 11.4766 21.9863C10.9251 21.9574 10.4545 22.381 10.4256 22.9326C10.3967 23.4841 10.8204 23.9546 11.3719 23.9835Z"
  }));
});
var StatusSpinner = AbstractIcon.withComponent(Icon);
StatusSpinner.displayName = 'StatusSpinner';
export default StatusSpinner;